import gql from 'graphql-tag'

export const GET_AUDIT_GROUPS = gql`
  query GetAuditGroups($skip: Int, $limit: Int, $search: String) {
    getAuditGroups(skip: $skip, limit: $limit, search: $search) {
      count
      groups {
        id
        name
        auditUserId
        auditUser {
          id
          firstName
          lastName
          userName
          email
        }
        clientIds
        clients {
          id
          firstName
          lastName
          userName
          clientCode
          strategyCode
          email
          phone
          plan {
            id
            name
          }
        }
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const CREATE_AUDIT_GROUP = gql`
  mutation CreateAuditGroup($data: CreateAuditGroupInput!) {
    createAuditGroup(data: $data) {
      id
      name
      auditUserId
      clientIds
    }
  }
`

export const UPDATE_AUDIT_GROUP = gql`
  mutation UpdateAuditGroup($data: UpdateAuditGroupInput!) {
    updateAuditGroup(data: $data) {
      id
      name
      auditUserId
      clientIds
    }
  }
`

export const DELETE_AUDIT_GROUP = gql`
  mutation DeleteAuditGroup($id: ID!) {
    deleteAuditGroup(id: $id)
  }
`
